import React, { useMemo } from 'react';
import classNames from 'classnames';
import ReportDetails from 'components/ReportDetails';
import ResolvePopup from 'components/ResolvePopup';
import {
  REPORT_ACTION_TRANSLATION,
  REPORT_ACTION_ICONS,
  FILE_UPLOAD_FAILED_COPY,
} from '../../utils';
import { DataRoomReport, ERROR_REPORT_ACTIONS } from '../../types';
import { useTranslation } from 'react-i18next';
import { MAX_SIZE_COPY } from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/data/DataTypes';
import TransWithNda from 'components/TransWithNda';
import { getArrayLength, getJoinedWordsWithComma } from 'utils';

import './ReportLog.styles.scss';

type ReportLogProps = {
  className?: string;
  report: DataRoomReport;
};

const ReportLog: React.FC<ReportLogProps> = (props) => {
  const { className, report } = props;
  const {
    action,
    createdAt,
    count,
    memberName,
    memberEmail,
    oldDocumentName,
    changedAccessMemberName,
    changedAccessMemberEmail,
    changedAccessMemberRole,
    timeSpent,
    documentNames,
    shareableLinkNames,
    rfiNames,
    memberIpAddress,
    fileUploadErrorCode,
    isMemberVerified,
    envelopeTemplateName,
  } = report;

  const { t } = useTranslation();

  const classes = classNames('report-log', className, {
    error: ERROR_REPORT_ACTIONS.includes(action),
  });

  const listOfElements = useMemo(
    () => [
      ...(documentNames ?? []),
      ...(rfiNames ?? []),
      ...(shareableLinkNames ?? []),
    ],
    [documentNames, rfiNames, shareableLinkNames],
  );

  const listLength = getArrayLength(listOfElements);

  const itemsCount = count || listLength || 1;

  const popupContent = useMemo(
    () => (
      <div className="resolve-popup-ul">
        {listOfElements.map((item) => (
          <div key={item}>{item}</div>
        ))}
      </div>
    ),
    [listOfElements],
  );

  const text = (
    <TransWithNda
      isParagraph={false}
      i18nKey={REPORT_ACTION_TRANSLATION[action]}
      envelopeTemplateName={envelopeTemplateName}
      values={{
        count: itemsCount,
        memberName: memberName || memberEmail,
        memberEmail,
        oldDocumentName,
        changedAccessMemberName:
          changedAccessMemberName || changedAccessMemberEmail,
        changedAccessMemberRole,
        timeSpent,
        memberIpAddress,
        documentName: getJoinedWordsWithComma(documentNames),
        rfiName: getJoinedWordsWithComma(rfiNames),
        shareableLinkName: getJoinedWordsWithComma(shareableLinkNames),
        notVerified: isMemberVerified ? '' : t('notVerifiedInBrackets'),
        errorType: t(FILE_UPLOAD_FAILED_COPY[fileUploadErrorCode], {
          fileLimit: MAX_SIZE_COPY,
        }),
      }}
      {...(listLength && {
        components: {
          popup: <ResolvePopup onHover popupContent={popupContent} />,
        },
      })}
    />
  );

  return (
    <ReportDetails
      className={classes}
      text={text}
      createdAt={createdAt}
      icon={REPORT_ACTION_ICONS[action]}
    />
  );
};

export default ReportLog;
